export const START_NODE_WIDTH = 96;
export const END_NODE_WIDTH = 96;
export const NODE_SIZE = '8px';
